(function () {
    'use strict';
    var isMobile = window.innerWidth < 1024;
    
    function close_accordion_section() {
        $('.accordion-wrapper .accordion-section-title').removeClass('current');
        $('.accordion-wrapper .accordion-section-content').slideUp(300).removeClass('open');
    }
 
    $(document).ready(function() {
        $('.accordion-section-title').on('click', function (e) {
            // Grab current anchor value
            var that = $(this),
                thatTarget = $(this).data('target');
 
            if (that.hasClass('current')) {
                close_accordion_section();
            } else {
                close_accordion_section();
                // Add active class to section title
                $(this).addClass('current');
                // Open up the hidden content panel
                $('.accordion-wrapper ' + thatTarget).slideDown(300).addClass('open');
            }
 
            var topAccordion;
            var offset;
 
            if(isMobile){
                topAccordion = $('.accordion-section [data-target="' + thatTarget + '"]');
                offset = 50;
            }
            else{
                topAccordion = $('.accordion-section [data-target="' + thatTarget + '"]');
                offset = 150;
            }
 
            window.setTimeout(function(){
                $('html, body').stop().animate({
                    scrollTop: topAccordion.offset().top - offset
                }, 1000);
            }, 300); // scroll happens after the opening animation
 
            return false;
        });
    });
 
 })();